import { useEffect, useState } from "react";
import CRMService from "../../services/crm.service";
import { formatContactPhone } from "./presentation";

export default function ContactSearch({ onSelect, placeholder = "Search all owners, guests, leads and other contacts…", ariaLabel = "Search all contacts" }) {
  const [term, setTerm] = useState("");
  const [page, setPage] = useState(0);
  const [results, setResults] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setResults([]);
    setTotal(0);
    setError("");
    setLoading(Boolean(term.trim()));
    if (!term.trim()) return;
    const timer = setTimeout(async () => {
      try {
        const { data } = await CRMService.searchAllPeople({ search_term: term, page, per: 20 });
        if (active) { setResults(data.paginated || []); setTotal(Number(data.total) || 0); }
      } catch (_) {
        if (active) setError("Unable to search contacts. Please try again.");
      } finally {
        if (active) setLoading(false);
      }
    }, 300);
    return () => { active = false; clearTimeout(timer); };
  }, [term, page]);

  const select = async (person) => {
    setError("");
    try {
      const contact = person.contact_id
        ? { ...(await CRMService.getContactById(person.contact_id)).data, crm_identity_id: person.crm_identity_id }
        : { ...person, id: person.guest_id || person.crm_identity_id, _type: "guest" };
      if (!contact.id) throw new Error("Contact unavailable");
      onSelect(contact);
      setTerm("");
    } catch (_) { setError("Unable to open this contact. Please try again."); }
  };
  return <div className="crm-global-search">
    <input type="search" className="crm-search-input" aria-label={ariaLabel}
      placeholder={placeholder} value={term}
      onChange={(event) => { setTerm(event.target.value); setPage(0); }} />
    {term.trim() && <div className="crm-global-search-results" aria-label="Contact search results">
      {loading ? <p role="status">Searching…</p> : <>
        {error && <p role="alert">{error}</p>}
        {!error && <p role="status">{total} matching contacts</p>}
        {results.map((person) => <button type="button" className="crm-search-result" key={person.crm_identity_id} onClick={() => select(person)}>
          <strong>{person.first_name} {person.last_name}</strong>
          <span>{person.category === "leads" ? "Lead" : person.category}</span>
          <small>{person.email} {formatContactPhone(person.formatted_phone)}</small>
        </button>)}
        {page > 0 && <button type="button" onClick={() => setPage(page - 1)}>Previous</button>}
        {(page + 1) * 20 < total && <button type="button" onClick={() => setPage(page + 1)}>Next</button>}
      </>}
    </div>}
  </div>;
}
